import React from "react";
import styled from "styled-components";

const BannerContainer = styled.div<any>`
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
	max-width: 28rem;
	background-color: transparent;
	color: rgba(255, 255, 255, 0.5);
	border-radius: 0.5rem;
	margin: 0 auto;
`;

const IconImg = styled.img`
	width: 24px;
	height: 24px;
	flex-shrink: 0;
`;

const Message = styled.p`
	margin: 0;
    font-size: 12px;
    line-height:15px;
	font-weight: 500;
    text-align: left;
`;

const BannerWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 0 0 1rem 0;
`;

interface InfoBannerProps {
	message: string;
}

const InfoBanner = ({ message }: InfoBannerProps) => {
	return (
		<BannerWrapper>
			<BannerContainer>
				<IconImg alt="info-icon" src="https://res.cloudinary.com/xook/image/upload/v1739186996/app.xook.ai/Icon_for_item_discrepancy_rcbtzj.png">
				</IconImg>
				<Message>{message}</Message>
			</BannerContainer>
		</BannerWrapper>
	);
};

export default InfoBanner;
